module.exports = __webpack_public_path__ + "img/weixinicon.ba690307.png";